import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function DifficultyAnalysis({ scoreLoading, scoreStats, policy }) {
    if (scoreLoading) {
        return (
            <Typography component="span" variant="body2" sx={{ color: 'text.secondary', mt: 1 }} align="left">
                (Loading...)
            </Typography>
        );
    }

    if (!policy || !policy.puzzleConfigure || scoreStats.totalWordsWithScore === null) {
        return null;
    }

    const config = policy.puzzleConfigure;
    
    // HARD: if lowScorePercentage >= lowScoreThresholdPercent (words with score between hardScoreMin and hardScoreMax)
    const isHard = scoreStats.lowScorePercentage >= config.lowScoreThresholdPercent;
    
    // EASY: if easyScorePercentage >= easyScoreThresholdPercent (words with score between easyScoreMin and easyScoreMax)
    // and low-score percentage is below the threshold
    const isEasy = !isHard && scoreStats.easyScorePercentage >= config.easyScoreThresholdPercent;
    
    const expectedDifficulty = isHard ? "HARD" : isEasy ? "EASY" : "MEDIUM";

    return (
        <Box sx={{ mt: 2, p: 1.5, backgroundColor: 'grey.50', borderRadius: 1 }}>
            <Typography variant="caption" sx={{ display: 'block', fontWeight: 'bold', mb: 1 }}>
                Difficulty Analysis:
            </Typography>
            {expectedDifficulty === "HARD" ? (
                <Typography variant="caption" sx={{ display: 'block', color: 'error.main' }}>
                    <strong>Why it's HARD:</strong> {scoreStats.lowScorePercentage?.toFixed(1)}% of words have score between {config.hardScoreMin} and {config.hardScoreMax} (threshold: ≥{config.lowScoreThresholdPercent}%)
                </Typography>
            ) : expectedDifficulty === "EASY" ? (
                <Typography variant="caption" sx={{ display: 'block', color: 'success.main' }}>
                    <strong>Why it's EASY:</strong> {scoreStats.easyScorePercentage?.toFixed(1)}% of words have score between {config.easyScoreMin} and {config.easyScoreMax} (threshold: ≥{config.easyScoreThresholdPercent}%) and low-score percentage ({scoreStats.lowScorePercentage?.toFixed(1)}%) is below {config.lowScoreThresholdPercent}%
                </Typography>
            ) : (
                <>
                    <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: 'error.main' }}>
                        <strong>Why it's not HARD:</strong> Low-score percentage is {scoreStats.lowScorePercentage?.toFixed(1)}% (needs ≥ {config.lowScoreThresholdPercent}%)
                    </Typography>
                    <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: 'success.main' }}>
                        <strong>Why it's not EASY:</strong> Only {scoreStats.easyScorePercentage?.toFixed(1)}% of words have score between {config.easyScoreMin} and {config.easyScoreMax} (needs ≥ {config.easyScoreThresholdPercent}%)
                    </Typography>
                    <Typography variant="caption" sx={{ display: 'block', color: 'warning.main', fontWeight: 'bold' }}>
                        <strong>Why it's MEDIUM:</strong> Words have score between {config.mediumScoreMin} and {config.mediumScoreMax}, doesn't meet EASY or HARD criteria
                    </Typography>
                </>
            )}
        </Box>
    );
}
